export default {
	sales: 'Sales',
	'cashbox-name': 'Cashbox name',
	'name-of-the-financial-account': 'Name of the financial account'
}